import {
  CartItems,
  CustomersData,
  FilterData,
  ProductData,
  RecentOrders,
  APIProductData,
  RecentOrderAPI,
  CinemaListAPI,
  PhonePrefixAPI,
  OrderHistoryAPI,
  ConfirmOrderStatusAPI,
  WebsiteStatus,
  RegionListAPI
} from '../models/ecommerce/EcommerceApp';
import {VIEW_TYPE} from '../../redux/reducers/Ecommerce';

export const GET_CART_ITEM = 'GET_CART_ITEM';
export const ADD_CART_ITEM = 'ADD_CART_ITEM';
export const GET_CUSTOMERS = 'GET_CUSTOMERS';
export const GET_ECOMMERCE_LIST = 'GET_ECOMMERCE_LIST';
export const SET_ECOMMERCE_LIST = 'SET_ECOMMERCE_LIST';
export const GET_RECENT_ORDER = 'GET_RECENT_ORDER';
export const REMOVE_CART_ITEM = 'REMOVE_CART_ITEM';
export const SET_FILTER_DATA = 'SET_FILTER_DATA';
export const SET_PRODUCT_DATA = 'SET_PRODUCT_DATA';
export const SET_PRODUCT_VIEW_TYPE = 'SET_PRODUCT_VIEW_TYPE';
export const UPDATE_CART_ITEM = 'UPDATE_CART_ITEM';
export const SET_ORDER_DATA = 'SET_ORDER_DATA';
export const NEW_CSO_ORDER = 'NEW_CSO_ORDER';
export const CONFIRM_CSO_ORDER_STATUS = 'CONFIRM_CSO_ORDER_STATUS';
export const SET_NEW_ORDER = 'SET_NEW_ORDER';
export const GET_CINEMA_LIST = 'GET_CINEMA_LIST';
export const GET_PHONE_PREFIX = 'GET_PHONE_PREFIX';
export const GET_ORDER_HISTORY = 'GET_ORDER_HISTORY';
export const GET_WEBSITE_STATUS = 'GET_WEBSITE_STATUS';
export const GET_REGION_LIST = 'GET_REGION_LIST';
export const CLEAR_CART_ITEM = 'CLEAR_CART_ITEM';
export const GET_CONFIRM_ORDER_STATUS = 'GET_CONFIRM_ORDER_STATUS';

//Add by Apple for Asyn Recux Thunk
export const GET_MENU_ITEM = 'GET_MENU_ITEM';

export interface GetMenuItem{
  type : typeof GET_MENU_ITEM;
  payload: APIProductData;
}

//Add by Apple for Set and Get order details
// export interface GetOrderDetailsAction {
//   type: typeof GET_ORDER_DETAILS;
//   payload: OrderDetails;
// }

// export interface SetOrderDetailsAction {
//   type: typeof SET_ORDER_DETAILS;
//   payload: OrderDetails;
// }

export interface SetCurrentOrder {
  type: typeof SET_ORDER_DATA;
  payload: RecentOrders;
}

export interface SetNewOrder {
  type: typeof SET_NEW_ORDER;
  payload: RecentOrders | null;
}

export interface GetEcommerceAction {
  type: typeof GET_ECOMMERCE_LIST;
  payload: ProductData[];
}

export interface GetCinemaListAction {
  type: typeof GET_CINEMA_LIST;
  payload: CinemaListAPI;
}

export interface GetRegionListAction {
  type: typeof GET_REGION_LIST;
  payload: RegionListAPI;
}

export interface GetCountryPhonePrefixAction {
  type: typeof GET_PHONE_PREFIX;
  payload: PhonePrefixAPI;
}

export interface GetWebsiteStatusAction {
  type: typeof GET_WEBSITE_STATUS;
  payload: WebsiteStatus;
}

export interface GetOrderHistoryAction {
  type: typeof GET_ORDER_HISTORY;
  payload: OrderHistoryAPI;
}

export interface SetEcommerceAction {
  type: typeof SET_ECOMMERCE_LIST;
  payload: ProductData;
}

export interface SetProductDetailAction {
  type: typeof SET_PRODUCT_DATA;
  payload: ProductData;
}

// export interface GetRecentOrdersAction {
//   type: typeof GET_RECENT_ORDER;
//   payload: {
//     orders: RecentOrders[];
//     orderCount: number;
//   };
// }

export interface NewCSOOrdersAction {
  type: typeof NEW_CSO_ORDER;
  payload: RecentOrderAPI;
}

export interface ConfirmCSOOrderStatusAction {
  type: typeof CONFIRM_CSO_ORDER_STATUS;
  payload: {data: ConfirmOrderStatusAPI ; setSubmitting: any; redirectToPayment: any; redirectToMenuList: any;};
}

export interface GetRecentOrdersAction {
  type: typeof GET_RECENT_ORDER;
  payload: RecentOrders[];
}

export interface GetCustomersAction {
  type: typeof GET_CUSTOMERS;
  payload: {customers: CustomersData[]; customerCount: number};
}

export interface GetCartItemsAction {
  type: typeof GET_CART_ITEM;
  payload: CartItems[];
}

export interface ClearCartItemsAction {
  type: typeof CLEAR_CART_ITEM;
  payload: null;
}

export interface GetConfirmOrderStatus {
  type: typeof GET_CONFIRM_ORDER_STATUS;
  payload: null;
}

export interface AddCartItemsAction {
  type: typeof ADD_CART_ITEM;
  payload: {data:ProductData, counter:number};
}

export interface RemoveCartItemsAction {
  type: typeof REMOVE_CART_ITEM;
  payload: CartItems;
}

export interface UpdateCartItemsAction {
  type: typeof UPDATE_CART_ITEM;
  payload: CartItems;
}

export interface SetProductViewTypeAction {
  type: typeof SET_PRODUCT_VIEW_TYPE;
  payload: VIEW_TYPE;
}

export interface SetFilterDataAction {
  type: typeof SET_FILTER_DATA;
  payload: FilterData;
}

export type EcommerceActionTypes =
  | GetEcommerceAction
  | SetEcommerceAction
  | SetProductDetailAction
  | GetRecentOrdersAction
  | GetCustomersAction
  | GetCartItemsAction
  | AddCartItemsAction
  | RemoveCartItemsAction
  | UpdateCartItemsAction
  | SetProductViewTypeAction
  | SetFilterDataAction
  | GetMenuItem
  | SetCurrentOrder
  | NewCSOOrdersAction
  | SetNewOrder
  | GetCinemaListAction
  | GetCountryPhonePrefixAction
  | GetOrderHistoryAction
  | ConfirmCSOOrderStatusAction
  | GetWebsiteStatusAction
  | GetRegionListAction
  | ClearCartItemsAction
  | GetConfirmOrderStatus;

